export const pathRoot = "/taxacusteio";

//export const pathRoot = "/";

export default pathRoot;
